<template>
    <transition
        v-bind:css="false"
        v-on:before-appear="beforeAppear"
        v-on:before-enter="beforeAppear"
        v-on:appear="appear"
        v-on:enter="appear"
        v-on:leave="leaveReverse"
    >
        <div
            v-if="show"
            class="masked-slide-container">
            <div class="content-holder" ref="content-ref">
                <slot
                    class="slot-content"
                >

                </slot>
            </div>
            <div 
                ref="mask-ref"
                class="masked-slide-mask">
            </div>
        </div>

    </transition>
</template>

<script>
import { TimelineLite, TweenLite, Power1, Back, Sine } from 'gsap';

export default {
    props: {
        animSpeed: {
            type: Number,
            default: 1
        }
    },

    data() {
        return {
            appearTimeline: new TimelineLite(),
            tween: TweenLite,
            show: true,
        }
        
    },

    methods: {
        beforeAppear(el, done) {
            const { ['content-ref']: img, ['mask-ref']: mask } = this.$refs;
            const imgTween = this.tween.set(img, {
                opacity: 0,
                transform: 'translateX(-25px)',
            });
            const maskTween = this.tween.set(mask, {
                transformOrigin: 'top left',
                transform: 'scaleX(0.02) scaleY(0)'
            });
        },

        appear(el, done) {

            const { ['content-ref']: img, ['mask-ref']: mask } = this.$refs;

            this.appearTimeline = new TimelineLite({
                onComplete: () => {
                    done();
                }
            })

            this.appearTimeline.to(mask, 0.3 * this.animSpeed, {
                ease: Sine.easeOut,
                transform: 'scaleX(0.02) scaleY(1)'
            })
            
            
            .to(mask, 0.25 * this.animSpeed, {
                ease: Sine.easeOut,
                transform: 'scaleX(1) scaleY(1)'
            }, 'showImage')
            .addLabel('showImage')
            .set(img, {
                // opacity: 0.5
            }, 'showImage')

            .to(img, 0.25 * this.animSpeed, {
                ease: Sine.easeInOut,
                transform: 'translateX(0)',
                opacity: 1
            }, 'showImage')
            .to(mask, 0.25 * this.animSpeed, {
                ease: Sine.easeInOut,
                transformOrigin: 'top right',
                transform: 'scaleX(0) scaleY(1)'
            }, 'showImage')

        },

        leave(el, done) {
            const { ['content-ref']: img, ['mask-ref']: mask } = this.$refs;

            const leaveTimeline = new TimelineLite({
                onComplete: () => {
                    done();
                }
            });

            leaveTimeline.to(img, 0.4, {
                ease: Sine.easeInOut,
                transformOrigin: 'top left',
                transform: 'translateX(90%)'
            })
            .to(img, 0.2, {
                ease: Sine.easeIn,
                opacity: 0,
                transformOrigin: 'top right',
                transform: 'scaleX(0)'
            })

        },
        
        leaveReverse(el, done) {
            const { ['content-ref']: img, ['mask-ref']: mask } = this.$refs;

            this.appearTimeline.eventCallback('onReverseComplete', () => {
                done();
            })
            this.appearTimeline.reverse();
        }
    }
    
}
</script>

<style lang="scss" >
    .masked-slide-container {
        // width: 100%;
        // height: 100%;
        position: relative;
        overflow: hidden;
        div.content-holder {

            img {
                
                display: block;
                margin-right: auto;
                margin-left: auto;
                height: auto;
                width: 100%;
            }
        }

        .masked-slide-mask {
            background-color: $primary-blue;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            position: absolute;
        }
    }
</style>
